import Api from 'services';
import LogRocket from "logrocket";

export const usersHasErrored = () => ({type: '[USERS_CONFIG] HAS_ERRORED'});
export const usersHasErrored_USER = () => ({type: '[USERS_CONFIG] HAS_ERRORED_USER'});
export const usersIsLoading = () => ({type: '[USERS_CONFIG] IS_LOADING'});
export const usersFetchSuccess = data => ({type: '[USERS_CONFIG] FETCH_SUCCESS', data});


// ACTION CREATORS

export const users_get_rows = () => async dispatch => {
    dispatch(usersIsLoading());
    Api.UsersConfig.getRows()
        .then(data => dispatch(usersFetchSuccess(data)))
        .catch(() => dispatch(usersHasErrored()));
};

export const users_get_rows_all = () => async dispatch => {
    dispatch(usersIsLoading());
    Api.UsersConfig.getAll()
        .then(data => dispatch(usersFetchSuccess(data)))
        .catch(() => dispatch(usersHasErrored()));
};

export const delete_user = (user) => async dispatch => {
    dispatch(usersIsLoading());
    await Api.UsersConfig.delete(user)
        .then(data => dispatch(usersFetchSuccess(data)))
        .catch(() => dispatch(usersHasErrored()));
};

export const create_user = (user) => async dispatch => {
    dispatch(usersIsLoading());
    await Api.UsersConfig.create(user)
        .then(data => dispatch(usersFetchSuccess(data)))
        .catch(erro => {
            dispatch(usersHasErrored_USER())

            let errorMessage = '';
            errorMessage = erro;
            throw errorMessage;
        })
};


export const save_permission = (user) => async dispatch => {
    dispatch(usersIsLoading());
    await Api.UsersConfig.savePermission(user)
        .then(data => dispatch(usersFetchSuccess(data)))
        .catch(() => dispatch(usersHasErrored()));
};
